<template>
  <el-button 
    class="cat-button"
    @click="handleclick"
  >
    <span v-if="$slots.default"> <slot /></span>
  </el-button>
</template>

<script>
export default {
   name: "ButtonReset",
   methods: {
    handleclick(e) {
      this.$emit("click", e);
    }
   }

}
</script>

<style>

</style>
